export default [
    {
        path: '/pages/phone/communityRecommend',
        name: '/pages/phone/communityRecommend',
        meta: { title: '小区推荐' },
        component: () => import('@/views/phone/communityRecommend.vue')
    },
    {
        path: '/pages/phone/indexMenu',
        name: '/pages/phone/indexMenu',
        meta: { title: '首页菜单' },
        component: () => import('@/views/phone/indexMenu.vue')
    },
    {
        path: '/pages/phone/storeAdsManage',
        name: '/pages/phone/storeAdsManage',
        meta: { title: '首页广告' },
        component: () => import('@/views/phone/storeAdsManage.vue')
    },
    {
        path: '/pages/phone/storeMsgManage',
        name: '/pages/phone/storeMsgManage',
        meta: { title: '首页通知' },
        component: () => import('@/views/phone/storeMsgManage.vue')
    }
] 